import { styled } from "@mui/material/styles";
import { Autocomplete, Button, IconButton, Paper, Table, TableCell, TableContainer, TableHead, TextField } from "@mui/material";
import { useColors } from "../../../../Context/ColorsContext";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import TableBody from "@mui/material/TableBody";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Badge from "@mui/material/Badge";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Toolbar from "@mui/material/Toolbar";

import { MediaQuerys } from "../../../../styles/GlobalStyle";
import { Check } from "@mui/icons-material";
import Switch from '@mui/material/Switch';

const { mobile, tablet, desktop } = MediaQuerys;

export const CustomTableHead = styled(TableHead)(() => {
  const { colors } = useColors();
  return {
    "& .MuiTableRow-head": {
      borderRadius: "8px",
    },
    "& .MuiTableRow-head .MuiTableCell-root span": {
      fontSize: "14px",
      lineHeight: 1.2,
      color: colors.navbarColor,
      [tablet]: {
        fontSize: "12px",
      }
    },
    "& .MuiTableRow-root .MuiTableCell-root": {
      paddingTop: "4px !important",
      paddingBottom: "4px !important",
      background: "#eeeeee"
    },
  };
});

export const CustomTable = styled(Table)(() => {
  return {
    borderRadius: "8px",
    "& .MuiTableBody-root .MuiTableRow-root .MuiTableCell-root": {
      padding: "6px 10px",
    },
  };
});

export const StickyColumn = styled(TableCell)(({ direction }) => {
  const { colors } = useColors();
  
  return {
    position: 'sticky',
    [direction]: 0,
    background: colors.white,
    width: "auto",
    borderTop: `1px solid #E0E0E0`,
    borderBottom: "none",
    borderRight: "none",
    borderLeft: "none",
    boxShadow: direction === "left" ? "2px 0px 2px 0px rgba(0, 0, 0, 0.05)" : (direction === "right" ? "-2px 0px 2px 0px rgba(0, 0, 0, 0.05)" : "none"),
  }
})

export const CustomTableCell = styled(TableCell)(() => {
  const { colors } = useColors();
  return {
    color: colors.buttonActionColor,
    fontSize: "14px",
    fontWeight: 600,
    paddingTop: "10px !important",
    paddingBottom: "10px !important",
    alignItems: "center",
    border: "none",
    [desktop]: {
      fontSize: "12px !important",
    },
  };
});

export const CustomCell = styled(TableCell)(({ dataHead }) => {
  const { colors } = useColors();
  const { sticky, direction } = dataHead

  return {
    position: sticky && 'sticky',
    [direction]: sticky && 0,
    background: sticky && colors.white,
    zIndex: sticky && '9',
    borderTop: "none",
    borderBottom: "none",
    borderRight: "none",
    borderLeft: "none",
    boxShadow: sticky ? (direction === "left" ? "2px 0px 2px 0px rgba(0, 0, 0, 0.05)" : "-2px 0px 2px 0px rgba(0, 0, 0, 0.05)") : "none",
    fontSize: "1rem",
    fontWeight: 600,
    paddingTop: "10px !important",
    paddingBottom: "10px !important",
    alignItems: "center",
    padding: "0 16px",
    color: colors.buttonActionColor,
    '& .MuiButtonBase-root': {
      position: 'unset',
    },
    "&:hover": {
      color: colors.buttonActionColor,
      opacity: 0.9
    },
    [desktop]: {
      fontSize: "0.75rem !important",
    },
  }
})

export const TableCellStatus = styled(TableCell)(() => ({
  display: "flex",
  alignItems: "flex-start",
  border: "none",
}));
export const ContainerCell = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
}));

export const Figure = styled("figure")(({ title }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  background: title,
  height: "30px",
  width: "30px",
  minWidth: "30px",
  borderRadius: "50%",
  marginRight: "10px !important",
}));

export const SectionInfo = styled("section")(() => ({
  display: "flex",
  flexDirection: "column"
}));

export const InfoCell = styled("div")(() => ({}));

export const Label = styled("label")(() => ({
  fontSize: "14px",
  paddingRight: "5px",
  [desktop]: {
    fontSize: "0.75rem !important",
  },
  [tablet]: {
    fontSize: "10px !important",
  },
  [mobile]: {
    paddingRight: "0px",
    fontSize: "0.70rem !important",
  },
}));

export const InputDate = styled("input")(({ theme }) => {
  const { colors } = useColors();
  return {
    // marginRight: "20px",
    borderBottom: "1px solid " + colors.grayFont,
    borderRadius: "3px",
    fontFamily: theme.typography.fontFamily,
    padding: "5px 10px",
    width: "150px",
    [desktop]: {
      width: "130px",
    },
    [tablet]: {
      width: "100px",
      height: 20,
    },
    [mobile]: {
      width: "80px",
      height: 20,
      padding: "5px 5px",
      // marginRight: "10px",
    },
  };
});

export const FigureHead = styled("figure")(() => ({
  display: "flex",
}));

export const Cell = styled(TableCell)(() => {
  return {
    borderTop: `1px solid #E0E0E0`,
    borderBottom: "none",
  };
});

export const IconAction = styled(IconButton)(() => {
  const { colors } = useColors();
  return {
    // visibility: !roleMatch && 'hidden',
    borderRadius: 20,
    pointerEvents: "pointer",
    background: colors.buttonActionColor,
    color: colors.white,
    marginLeft: 5,
    "&:hover": {
      backgroundColor: colors.buttonActionColor,
      opacity: 0.9,
      color: colors.white,
    },
    [desktop]: {
      fontSize: "0.25rem",
      width: '28px',
      height: '28px',
      "&MuiSvgIcon-root": {
        width: '16px'
      }
    },
    [tablet]: {
      height: 28,
      width: 28,
    },
    [mobile]: {
      display: "none",
    },
  };
});

export const ContainerIconAction = styled('div')(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    [mobile]: {
      display: "none",
    },
  }
})

export const CleanIcon = styled(CleaningServicesIcon)(() => {
  const { colors } = useColors();
  return {
    color: colors.white,
    fontSize: 18,
    [tablet]: {
      width: 17,
      height: 17,
      padding: '1px',
      '.MuiSvgIcon-root': {
        width: 16,
        height: 16,
      }
    },
    [desktop]: {
      width: '16px',
      height: '16px',
    }
  };
});

export const NewIcon = styled(AddCircleIcon)(() => {
  const { colors } = useColors();
  return {
    height: '20px',
    width: '20px',
    color: colors.white,
    // fontSize: 18,
    [desktop]: {
      height: '16px',
      width: '16px'
    }
  };
});

export const CustomIconButton = styled(IconButton)(() => {
  const { colors } = useColors();
  return {
    borderRadius: "8px",
    backgroundColor: colors.background,
    color: colors.buttonActionColor,
    "&:hover": {
      backgroundColor: colors.buttonActionColor,
      opacity: 0.9,
      color: colors.background,
    },
  };
});

export const TableContent = styled(TableBody)(() => ({
  ".MuiTableCell-root": {
    fontSize: "14px !important",
    [tablet]: {
      fontSize: "12px !important",
    },
  },
  [tablet]: {
    ".MuiTablePagination-displayedRows": {
      fontSize: "12px !important",
    },
    ".MuiTablePagination-selectLabel": {
      fontSize: "12px !important",
    },
  },
}));

export const CustomFormControl = styled(FormControl)(() => {
  const { colors } = useColors();
  return {
    width: "100%",
    height: "32px",
    borderRadius: "8px",
    border: "none",
    background: colors.white,
  };
});

export const CustomInputLabel = styled(InputLabel)(() => {
  const { colors } = useColors();
  return {
    fontSize: "14px",
    position: "absolute",
    top: "50%",
    left: "40%",
    transform: "translate(-50%, -50%)",
    color: colors.grayDemo,
    [tablet]: {
      fontSize: "12px",
    }
  };
});

export const CustomBadge = styled(Badge)(() => {
  return {
    color: "white",
    [desktop]: {
      "& .MuiBadge-badge": {
        minWidth: "15px !important",
        width: "15px !important",
        height: "15px !important",
      },
      fontSize: "0.75rem",
    },
  };
});

export const CustomSelect = styled(Select)(() => {
  return {
    width: "150px",
    height: "32px",
    [desktop]: {
      width: "110px",
      // height: 26,
    },
    [tablet]: {
      width: "120px",
      height: 26,
    },
    // [mobile]: {
    //   width: "80px",
    //   height: 20,
    // },
  };
});

export const CustomMenuItem = styled(MenuItem)(() => {
  return {
    [desktop]: {
      "& .MuiTypography-root": {
        fontSize: "0.75rem",
      },
    },
  };
});

//? Custom items date

export const ContainerInputsDate = styled("div")(() => {
  const { colors } = useColors();
  return {
    '& .MuiOutlinedInput-root': {
      background: colors.white,
      borderRadius: '8px',
      fontSize: '14px',
      height: '32px',
      '& fieldset': {
        borderColor: colors.grayDemo 
      }
    },
    '& .MuiFormLabel-root': {
      fontSize: "14px",
      color: colors.grayDemo,
      lineHeight: 1,
      [tablet]: {
        fontSize: "12px"
      }
    },
    '& .MuiInputBase-root': {
      fontSize: "14px",
      overflow: "hidden",
      paddingTop: '0px',
      [tablet]: {
        fontSize: "12px",
      },
    },
    '& .MuiStack-root': {
      paddingTop: '0px !important',
      overflow: 'visible !important',
    },
  }
});

export const ContainerGroup = styled("div")(({ needMagin }) => {
  return {
    display: "flex",
    alignItems: "center",
    gap: "0.50rem",
    flexDirection: "row",
    marginLeft: needMagin && 5,
  };
});

export const ContainerSearch = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  gap: "2px",
  alignItems: "center",
}));

export const CustomToolbar = styled(Toolbar)(({theme}) => {
  const { colors } = useColors();
  return {
    background: colors.white,
    borderRadius: '10px',
    border: '1px solid #e0e0e0',
    minHeight: "40px !important",
    padding: "5px 10px !important",
    [theme.breakpoints.down('md')]: {
      background: 'transparent',
      border: 'none',
      padding: "0px !important",
    },
  };
});

export const ContainerGroupSelects = styled('div')(() => {
  return {
    display: 'flex',
    flexDirection: 'row',
    width: "100%",
    justifyContent: 'space-between',
    gap: 6,
  }
})

export const ContainerFiltros = styled('div')(() => {
  return {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
  }
})

export const ContainerDates = styled('div')(() => {
  return {
    display: "flex",
    flexDirection: 'row',
    gap: '1rem',
  }
})

export const ContainerPrueba = styled('div')(() => {
  return {
    [mobile]: {
      width: '100%',
    }
  }
})

export const ContainerActions = styled('div')(() => {
  return {
    display: "flex",
    flexDirection: 'row',
    gap: '0.35rem',
    [mobile]: {
      display: 'none',
    }
  }
})

export const ContentCell = styled('div')(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    width: 'max-content'
  }
})

export const CustomAutocomplete = styled(Autocomplete)(() => ({
  width: '100%',
  borderRadius: 6,
  fontSize: 13,
  '.MuiInputBase-root': {
    paddingTop: "3px !important",
    paddingBottom: "3px !important",
    maxWidth: '57px !important',
    minWidth: '57px !important',
  },
  [mobile]: {
    '.MuiInputLabel-root': {
      fontSize: '0.75rem',
    },
  },
  [desktop]: {
    '.MuiFormLabel-root': {
      fontSize: '0.85rem'
    }
  }
}))

export const CustomTextField = styled(TextField)(() => {
  return {
    padding: 0,
    margin: 0,
    '.MuiInputBase-root .MuiInputAdornment-root': {
      position: 'relative',
      bottom: '-12px !important'
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: 'rgba(0, 0, 0, 0.4)',
      },
    },
    "& .MuiInputBase-root.Mui-disabled": {
      "& > fieldset": {
        borderColor: "rgba(0, 0, 0, 0.15)"
      }
    }
  }
})

export const CustomCheckIcon = styled(Check)(({ disabled }) => {
  const { colors } = useColors();
  return {
    color: disabled ? 'rgba(0, 0, 0, 0.15)' : colors.buttonActionColor,
    padding: 0,
    margin: 0
  }
})


//Custom Switch

export const ContainerSwitch = styled('div')(() => {
  const { colors } = useColors();
  return {
    border: `1px solid ${colors.grayDemo}`,
    borderRadius: '8px',
    padding: '0px 8px',
    height: '32px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    background: colors.white,
    width: '100%',
  }
})

export const LabelSwitch = styled('label')(() => {
  const { colors } = useColors();
  return {
    color: colors.grayDemo,
    fontSize: '14px',
    [tablet]: {
      fontSize: '12px',
    },
  }
})



export const CustomBtnFilter = styled(Button)(() => {
  const { colors } = useColors();
  return {
    display: 'none',
    height: 28,
    padding: '0 30px',
    color: colors.white,
    backgroundColor: colors.buttonActionColor,
    "&:hover": {
      backgroundColor: colors.buttonActionColor,
      opacity: 0.9,
      color: colors.white,
    },
    [tablet]: {
      display: 'flex',
      height: '28px',
      fontSize: '0.75rem',
    },
    [mobile]: {
      height: '25px',
    },
  }
})

export const PaperContainer = styled(Paper)(() => {
  return {
    width: "100%",
    marginTop: "1.3rem",
    borderRadius: "10px",
    "& .MuiTablePagination-root .MuiToolbar-root.MuiTablePagination-toolbar": {
      minHeight: "30px"
    },
  }
})

export const CustomTableContainer = styled(TableContainer)(({isCustom, isLotoWorkflow, theme}) => {
  return {
    height: 'calc(100vh - 320px)',
    [theme.breakpoints.up('sm')]: {
      height: isLotoWorkflow ? 'calc(100vh - 320px)' : (isCustom ? 'calc(100vh - 360px)' : 'calc(100vh - 320px)'),
    },
    [theme.breakpoints.up('md')]: {
      height: isLotoWorkflow ? 'calc(100vh - 270px)' : (isCustom ? 'calc(100vh - 310px)' : 'calc(100vh - 320px)'),
    },
    [theme.breakpoints.up('xl')]: {
      height: isLotoWorkflow ? 'calc(100vh - 280px)' : (isCustom ? 'calc(100vh - 280px)' : 'calc(100vh - 320px)'),
    },
    borderRadius: "10px",
  }
})

export const ContainerDiv = styled('div')(({ myWork }) => {
  return {
    display: 'flex',
    justifyContent: myWork && 'center',
    alignItems: myWork && 'center',
    flexDirection: 'row',
    width: 'inherit'
  }
})

export const ContainerItem = styled('div')(({ show }) => {
  return {
    display: show === false ? 'none' : null,
    padding: '5px',
    width: 'max-content',
    fontWeight: "bold",
  }
})

export const CleanButton = styled(Button)(() => {
  const { colors } = useColors();
  return {
    height: "32px",
    width: "100%",
    textTransform: "none",
    backgroundColor: colors.white,
    color: colors.buttonActionColor,
    border: `1px solid #E0E0E0`,
    boxShadow: "none",
    borderRadius: 8,
    fontSize: "14px",
    "&:hover": {
      backgroundColor: colors.white,
      opacity: 0.9,
      boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
    },
    "& .MuiSvgIcon-root": {
      color: colors.buttonActionColor,
    },
    "& .MuiButton-icon": {
      marginRight: 2,
    },
    "& .text": {
      color: colors.grayDemo,
    },
    [tablet]: {
      fontSize: "12px !important",
    },
  };
});